import { BaseClass } from './BaseClass';
import { PERMISSIONS } from './Permissions';

export class Customers extends BaseClass {
  Download: boolean;
  AddPoint: boolean;
  DeductPoints: boolean;
  AddBalance: boolean;
  DeductBalacnce: boolean;
  constructor(obj: any = PERMISSIONS.Customers) {
    super(obj);
    this.Download = !!obj?.Download;
    this.AddPoint = !!obj?.AddPoint;
    this.DeductPoints = !!obj?.DeductPoints;
    this.AddBalance = !!obj?.AddBalance;
    this.DeductBalacnce = !!obj?.DeductBalacnce;
  }
}
